import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Card,
    CardContent,
    Container,
    Grid,
    Typography,
    Divider,
    colors
} from '@material-ui/core';

import {
    Alert
} from '@material-ui/lab';

import {
    FieldError
} from '../../../common';

import {
    Form,
    Formik,
    Field
} from 'formik';

import {
    Switch,
    TextField,
    CheckboxWithLabel
} from 'formik-material-ui';

import { PageContext } from '../PageContext';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
   sectionTitle: {
      color: "#7957d5"
   },

    title: {
        fontSize: "1.2em"
    },
    content: {
        marginTop: theme.spacing(4)
    },
    field: {
        width: "100%"
    }
}));

export const ServicesForm = ({
    formRef,
    errors,
    validationSchema,
    disabled,
    onBlur,
    onSubmit,
    ...props }) => {
    const classes = useStyles();

    const { t, i18n } = useTranslation();

    const {
        state
    } = useContext(PageContext);

    const {
        settings
    } = state;

    const getInitialValues = () => {
        return {
            oneSignalAppId: settings.oneSignalAppId ? settings.oneSignalAppId : "",
            shareAppAndroid: settings.shareAppAndroid ? settings.shareAppAndroid : "",
            shareAppIos: settings.shareAppAndroid ? settings.shareAppIos : "",
            sendGripApiKey: settings.sendGripApiKey ? settings.sendGripApiKey : ""
        };
    }

    const submitClickHandler = (values, actions) => {
        if (onSubmit) onSubmit(values, () => actions.setSubmitting(false));
    }

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardContent>
                <Container maxWidth="lg" className={classes.content}>
                    <Formik
                        enableReinitialize
                        initialValues={getInitialValues()}
                        onSubmit={submitClickHandler}
                        innerRef={formRef}
                        validationSchema={validationSchema}
                        validateOnChange={false}
                        validateOnBlur={true}
                        validate={(values) => {
                            if (onBlur) onBlur(values);
                        }}>
                        {(props) => {
                            const {
                                values,
                                isSubmitting,
                                handleSubmit,
                                setFieldValue
                            } = props;
                            return (
                                <Form noValidate autoComplete="off">
                                    <Grid container spacing={3}>
                                     <Grid item xs={12}>
                                        <Typography className={classes.sectionTitle} variant="h5" component="h2">
                                                Push Notifications
                                            </Typography>
                                        </Grid>
                                        {/* <Grid item xs={12}>
                                            <Alert severity="info">
                                                {t("LabelOneSignalHelp")}
                                                Requires your OneSignal User Auth Key, available in
                                                <a href="https://documentation.onesignal.com/docs/accounts-and-keys#user-auth-key">Account & API Keys.</a>
                                            </Alert>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                className={classes.field}
                                                name="oneSignalAuthKey"
                                                type="text"
                                                variant="outlined"
                                                label={t("LabelOneSignalAuthKey")}
                                                helperText={t("HelperOneSignalAuthKey")}
                                                component={TextField}
                                                disabled={disabled}
                                            />
                                            <FieldError
                                                name="oneSignalAuthKey"
                                                errors={errors}
                                            />
                                        </Grid> */}
                                        <Grid item xs={12}>
                                            <Field
                                                className={classes.field}
                                                name="oneSignalAppId"
                                                type="text"
                                                variant="outlined"
                                                label={t("LabelOneSignalAppId")}
                                                helperText={t("HelperOneSignalAppId")}
                                                component={TextField}
                                                disabled={disabled}
                                            />
                                            <FieldError
                                                name="oneSignalAppId"
                                                errors={errors}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Divider variant="fullWidth" />
                                        </Grid>
                                     <Grid item xs={12}>
                                        <Typography className={classes.sectionTitle} variant="h5" component="h2">
                                                SendGrid
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                className={classes.field}
                                                name="sendGripApiKey"
                                                type="text"
                                                variant="outlined"
                                                label={t("LabelSendGripApiKey")}
                                                helperText={t("HelperSendGripApiKey")}
                                                component={TextField}
                                                disabled={disabled}
                                            />
                                            <FieldError
                                                name="sendGripApiKey"
                                                errors={errors}
                                            />
                                        </Grid>
                                    </Grid>
                                </Form>
                            );
                        }}
                    </Formik>
                </Container>
            </CardContent>
        </Card>
    );
}